<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Abertura de Pré-Matrícula</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-btn
          v-if="$can(['preMatriculaPeriodos.criar', 'preMatriculaPeriodos.*'])"
          color="success"
          class="mb-2"
          @click="$router.push({ name: 'preMatriculaPeriodos.create' })"
        >
          Abrir período
        </v-btn>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="cabecalhos"
          :items="periodos"
          :loading="carregando"
          :options.sync="opcoes"
          :server-items-length="total"
          :footer-props="{ 'items-per-page-options': [15, 30, 50] }"
          no-data-text="Nenhum período de pré-matrícula cadastrado."
          class="elevation-1"
        >
          <template v-slot:item.ano="{ item }">
            {{ item.ano ? item.ano.descricao : "- - -" }}
          </template>
          <template v-slot:item.data_inicio="{ item }">
            {{ formatarData(item.data_inicio) }}
          </template>
          <template v-slot:item.data_fechamento="{ item }">
            {{ formatarData(item.data_fechamento) }}
          </template>
          <template v-slot:item.descontos="{ item }">
            <span v-if="item.descontos.length === 0" class="grey--text">Sem desconto</span>
            <div v-for="desconto in item.descontos" :key="desconto.id" class="caption">
              {{ formatarData(desconto.data) }}: {{ desconto.desconto_matriculado | currency }} /
              {{ desconto.desconto_nao_matriculado | currency }}
            </div>
          </template>
          <template v-slot:item.ativo="{ item }">
            <v-chip small label :color="item.ativo ? 'success' : 'grey'" dark>
              {{ item.ativo ? "Ativo" : "Inativo" }}
            </v-chip>
            <v-chip v-if="estaCongelado(item)" small label class="ml-1" color="blue lighten-4">
              Com pré-matrículas
            </v-chip>
          </template>
          <template v-slot:item.acoes="{ item }">
            <e-acoes-do-periodo
              :periodo="item"
              :congelado="estaCongelado(item)"
              @editar="editar(item)"
              @alternar-situacao="alternarSituacao(item)"
              @excluir="excluir(item)"
            />
          </template>
        </v-data-table>
        <p class="caption grey--text mt-2">
          Valores de desconto: aluno matriculado no ano anterior / aluno não matriculado no ano
          anterior.
        </p>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import EAcoesDoPeriodo from "@/components/PreMatriculas/EAcoesDoPeriodo.vue";
import { formatarData, periodoEstaCongelado } from "@/components/PreMatriculas/helpers";

export default {
  name: "PreMatriculaPeriodosPage",
  components: { EAcoesDoPeriodo },
  data() {
    return {
      periodos: [],
      total: 0,
      carregando: false,
      opcoes: { page: 1, itemsPerPage: 15 },
      cabecalhos: [
        { text: "Ano letivo", value: "ano", sortable: false },
        { text: "Início", value: "data_inicio", sortable: false },
        { text: "Fechamento (vencimento)", value: "data_fechamento", sortable: false },
        { text: "Descontos", value: "descontos", sortable: false },
        { text: "Situação", value: "ativo", sortable: false },
        { text: "Ações", value: "acoes", sortable: false },
      ],
    };
  },
  watch: {
    opcoes: {
      handler() {
        this.listar();
      },
      deep: true,
    },
  },
  methods: {
    formatarData,
    estaCongelado: periodoEstaCongelado,
    async listar() {
      this.carregando = true;
      try {
        const resposta = await this.$services.preMatriculasService.listarPeriodos(
          this.opcoes.page,
          this.opcoes.itemsPerPage
        );
        this.periodos = resposta.data;
        this.total = resposta.total;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregando = false;
    },
    editar(periodo) {
      this.$router.push({ name: "preMatriculaPeriodos.edit", params: { periodo_id: periodo.id } });
    },
    async alternarSituacao(periodo) {
      this.$loaderService.open(periodo.ativo ? "Desativando período" : "Ativando período");
      try {
        await this.$services.preMatriculasService.alterarSituacaoDoPeriodo(
          periodo.id,
          !periodo.ativo
        );
        this.$toast.success(periodo.ativo ? "Período desativado." : "Período ativado.");
        await this.listar();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    excluir(periodo) {
      this.$modals.danger({
        title: "Excluir período",
        message: `Excluir o período de ${formatarData(periodo.data_inicio)} a ${formatarData(
          periodo.data_fechamento
        )}?`,
        buttons: [
          { text: "Cancelar", callback: () => this.$modals.close(), props: { small: true } },
          {
            text: "Excluir",
            callback: () => this.confirmarExclusao(periodo),
            props: { color: "error", small: true },
          },
        ],
      });
    },
    async confirmarExclusao(periodo) {
      this.$modals.close();
      this.$loaderService.open("Excluindo período");
      try {
        await this.$services.preMatriculasService.excluirPeriodo(periodo.id);
        this.$toast.success("Período excluído.");
        await this.listar();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>
